<template>
  <b-card class="w-100 h-100">
    <div class="w-100">
      <h3>
        {{ clueData.clueCode }} -
        {{ clueData.clueDateTimeStr }}
      </h3>
      <h4>
        {{ clueData.levelDesc }} : {{ clueData.statusDesc }} -
        {{ clueData.createTrackingStr }}
      </h4>

      <div class="d-flex justify-content-end">
        <button
          v-if="isAdminRole"
          @click="onDeleteBtnClicked"
          type="button"
          class="btn btn-danger"
        >
          ลบเรื่องแจ้งเบาะแส
        </button>
      </div>
    </div>
    <ValidationObserver ref="form">
      <b-row>
        <!-- ชื่อเรื่องแจ้งเบาะแส -->
        <b-col cols="12" class="">
          <b-form-group>
            <label for="clueIssue">
              ชื่อเรื่องแจ้งเบาะแส <span class="text-danger">*</span>
            </label>
            <ValidationProvider
              rules="required"
              name="ชื่อเรื่องแจ้งเบาะแส"
              v-slot="{ errors }"
            >
              <b-form-input
                id="clueIssue"
                v-model="clueData.clueIssue"
                :readonly="isReadonly"
                placeholder="กรุณากรอก ชื่อเรื่องแจ้งเบาะแส"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>
        </b-col>

        <!-- รายละเอียดเรื่องแจ้งเบาะแส -->
        <b-col cols="12" class="">
          <b-form-group>
            <label for="clueDetail">
              รายละเอียดเรื่องแจ้งเบาะแส<span class="text-danger">*</span>
            </label>
            <ValidationProvider
              rules="required"
              name="รายละเอียดเรื่องแจ้งเบาะแส"
              v-slot="{ errors }"
            >
              <b-form-textarea
                v-model="clueData.clueDetail"
                :readonly="isReadonly"
                rows="5"
              ></b-form-textarea>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>
        </b-col>

        <!-- ชื่อสถานที่พบหรือชื่อผู้ประกอบการ -->
        <b-col cols="12" class="">
          <b-form-group>
            <label for="companyName">
              ชื่อสถานที่พบหรือชื่อผู้ประกอบการ
              <span class="text-danger">*</span>
            </label>
            <ValidationProvider
              rules="required"
              name="ชื่อสถานที่พบหรือชื่อผู้ประกอบการ"
              v-slot="{ errors }"
            >
              <b-form-input
                id="companyName"
                v-model="clueData.companyName"
                :readonly="isReadonly"
                placeholder="กรุณากรอก ชื่อสถานที่พบหรือชื่อผู้ประกอบการ"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>
        </b-col>

        <!-- longdo-map -->
        <b-col cols="12" v-if="clueData !== null">
          <longdo-map
            v-if="
              clueData.companyLongitude !== null &&
                clueData.companyLatitude !== null &&
                clueData.companyLongitude !== '' &&
                clueData.companyLatitude !== '' &&
                clueData.companyLongitude !== undefined &&
                clueData.companyLatitude !== undefined
            "
            @load="eventMap"
            :zoom="10"
            :lastView="false"
            :location="{
              lon: clueData.companyLongitude,
              lat: clueData.companyLatitude,
            }"
            style="height: 420px;"
          >
            <longdo-map-marker
              :location="{
                lon: clueData.companyLongitude,
                lat: clueData.companyLatitude,
              }"
              :title="clueData.address1"
              :detail="
                'long:' +
                  clueData.companyLongitude +
                  ',lat:' +
                  clueData.companyLatitude
              "
            />
          </longdo-map>
          <span v-else>*ผู้ร้องไม่ได้ระบุพิกัดบนแผนที่</span>
        </b-col>

        <!-- <b-col cols="12" class="mb-2">
          <LongdoMap @load="onLongdoLoad" :center="map.center" :apiKey="map.apiKey" >
            <template slot-scope="{ map }">
              <LongdoMapMarker
                @load="onMarkerLoad"
                :map="map"
                :marker="marker"
              ></LongdoMapMarker>
            </template>
          </LongdoMap>
        </b-col> -->

        <!-- ที่อยู่ที่สามารถติดต่อได้ผู้ถูกแจ้งเบาะแส -->
        <b-card class="m-1 border border-primary w-100">
          <h4>ที่อยู่ที่สามารถติดต่อได้ผู้ถูกแจ้งเบาะแส</h4>
          <b-row>
            <b-col cols="12" class="">
              <b-form-group>
                <label for="address">ที่อยู่</label>
                <ValidationProvider name="ที่อยู่" v-slot="{ errors }">
                  <b-form-input
                    id="ampher"
                    v-model="clueData.address1"
                    :readonly="isReadonly"
                    placeholder="กรุณากรอก ที่อยู่"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="tumbon">ตำบล</label>
                <ValidationProvider name="ตำบล" v-slot="{ errors }">
                  <b-form-input
                    id="tumbon"
                    v-model="clueData.tumbon"
                    :readonly="isReadonly"
                    placeholder="กรุณากรอก ตำบล"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="ampher">อำเภอ</label>
                <ValidationProvider name="อำเภอ" v-slot="{ errors }">
                  <b-form-input
                    id="ampher"
                    v-model="clueData.ampher"
                    :readonly="isReadonly"
                    placeholder="กรุณากรอก อำเภอ"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="province">จังหวัด</label>
                <ValidationProvider name="จังหวัด" v-slot="{ errors }">
                  <b-form-input
                    id="province"
                    v-model="clueData.province"
                    :readonly="isReadonly"
                    placeholder="กรุณากรอก จังหวัด"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="Tel">รหัสไปรษณีย์</label>
                <ValidationProvider name="รหัสไปรษณีย์" v-slot="{ errors }">
                  <b-form-input
                    id="zipCode"
                    v-model="clueData.zipCode"
                    :readonly="isReadonly"
                    placeholder="กรุณากรอก รหัสไปรษณีย์"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <!-- ช่องทางที่พบเบาะแส -->
        <b-card class="m-1 border border-primary w-100">
          <b-col cols="12">
            <ContactDisplay
              :contacts="clueData.clueContacts"
              :labelTitle="'ช่องทางที่พบเบาะแส'"
            />
          </b-col>
        </b-card>

        <!-- ข้อมูลติดต่อกลับผู้แจ้งเบาะแส -->
        <b-card class="m-1 border border-primary w-100">
          <h4>ข้อมูลติดต่อกลับผู้แจ้งเบาะแส</h4>
          <b-row>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="companyName">ชื่อ</label>
                <ValidationProvider name="ชื่อ" v-slot="{ errors }">
                  <b-form-input
                    id="name"
                    v-model="clueData.name"
                    :readonly="isReadonly"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="lastname">นามสกุล</label>
                <ValidationProvider name="นามสกุล" v-slot="{ errors }">
                  <b-form-input
                    id="lastname"
                    v-model="clueData.lastname"
                    :readonly="isReadonly"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="email">อีเมล</label>
                <ValidationProvider name="อีเมล" v-slot="{ errors }">
                  <b-form-input
                    id="email"
                    v-model="clueData.email"
                    :readonly="isReadonly"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="">
              <b-form-group>
                <label for="Tel">เบอร์โทร</label>
                <ValidationProvider name="เบอร์โทร" v-slot="{ errors }">
                  <b-form-input
                    id="Tel"
                    v-model="clueData.tel"
                    :readonly="isReadonly"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-row>
    </ValidationObserver>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BListGroup,
} from "bootstrap-vue";

import FileUploadWithSelect from "@/views/Complaint/Utils/FileUpload/FileUploadWithSelect.vue";
import ContactDisplay from "@/views/Complaint/Utils/Contact/ContactDisplay.vue";
import * as userData from "@/auth/localStorageUtils.js";
import * as clueStore from "@/store/api/clue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { LongdoMap, LongdoMapMarker } from "longdo-map-vue";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BListGroup,
    ValidationObserver,
    ValidationProvider,
    ContactDisplay,
    LongdoMap,
    LongdoMapMarker,
  },
  props: {
    clueData: null,
  },
  data() {
    return {
      isReadonly: true,
      isAdminRole: userData.isAdminRole(),
    };
  },
  mounted() {
    LongdoMap.init({ apiKey: "ef7ba3e6cea0104eb5aafaf4b4733e0f" });
  },
  methods: {
    eventMap(map) {
      console.log("map load");
      map.Ui.Crosshair.visible(false);
      map.Ui.lockMap(true);
    },
    onDeleteBtnClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        // console.log("หลุด", result.value);

        if (result.value) {
          clueStore
            .deleteClue(_this.clueData.clueId, userData.userId())
            .then((response) => {
              if (response.data.success) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกข้อมูลของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                if (_this.$route.name == "ClueActionManage") {
                  window.open(
                    _this.$router.resolve({
                      name: "ClueAction",
                    }).href,
                    "_self",
                  );
                } else {
                  window.open(
                    _this.$router.resolve({
                      name: "ClueSearch",
                    }).href,
                    "_self",
                  );
                }
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((err) => {
              console.log("error", err);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
  },
};
</script>

<style></style>
